import styled from '@emotion/styled';
import { rem } from '@triumph/design-system';

export const MentionContainer = styled.div`
    position: relative;
`;

/**
 * `position: fixed` because the dropdown is anchored to the caret's *viewport*
 * rect (from getBoundingClientRect), not to the container's offset parent. This
 * keeps it correctly placed regardless of scroll containers or modal overflow.
 */
export const DropdownContainer = styled.div<{ top: number; left: number }>`
    position: fixed;
    top: ${({ top }) => top}px;
    left: ${({ left }) => left}px;
    z-index: 1100;
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: ${rem(6)};
    box-shadow: 0 ${rem(4)} ${rem(12)} rgba(0, 0, 0, 0.12);
    max-height: ${rem(240)};
    overflow-y: auto;
    min-width: ${rem(240)};
    max-width: ${rem(360)};
    padding: ${rem(4)} 0;
`;

export const SuggestionItem = styled.div<{ isSelected: boolean }>`
    padding: ${rem(8)} ${rem(12)};
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: ${rem(8)};
    background: ${({ isSelected }) => (isSelected ? '#f3f4f6' : 'transparent')};

    &:hover {
        background: #f3f4f6;
    }
`;

export const SuggestionTextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 0;
    flex: 1;
`;

export const SuggestionLabel = styled.span`
    font-size: ${rem(13)};
    color: #1f2937;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const SuggestionTitle = styled.span`
    font-size: ${rem(10)};
    color: #6b7280;
    font-weight: 400;
    text-align: right;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: ${rem(160)};
`;

export const SuggestionMetaColumn = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: ${rem(2)};
    margin-left: auto;
    flex-shrink: 0;
    min-width: 0;
`;

export const SuggestionEmail = styled.span`
    font-size: ${rem(11)};
    color: #6b7280;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

const badgeColors: Record<string, { color: string; bg: string; border: string }> = {
    assignee: { color: '#2679ad', bg: '#e1f0f9', border: '#b8d8ea' },
    orpUser: { color: '#1a7f4b', bg: '#e6f4ec', border: '#b7dfc5' },
    poc: { color: '#7c3aed', bg: '#ede9fe', border: '#c4b5fd' },
    condition: { color: '#9a6700', bg: '#fdf3d7', border: '#f3e0a3' },
};

export const SuggestionAvatar = styled.img`
    width: ${rem(24)};
    height: ${rem(24)};
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
`;

export const SuggestionAvatarPlaceholder = styled.div`
    width: ${rem(24)};
    height: ${rem(24)};
    border-radius: 50%;
    background: #e5e7eb;
    flex-shrink: 0;
`;

export const SourceBadge = styled.span<{ source: string }>`
    flex-shrink: 0;
    margin-left: auto;
    font-size: ${rem(10)};
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    padding: ${rem(2)} ${rem(6)};
    border-radius: ${rem(4)};
    color: ${({ source }) => badgeColors[source]?.color ?? '#9a6700'};
    background: ${({ source }) => badgeColors[source]?.bg ?? '#fdf3d7'};
    border: 1px solid ${({ source }) => badgeColors[source]?.border ?? '#f3e0a3'};
`;

export const EmptyMessage = styled.div`
    padding: ${rem(8)} ${rem(12)};
    font-size: ${rem(12)};
    color: #9ca3af;
    font-style: italic;
`;
